import type { DeckPassiveId } from '@cards/cards';

/**
 * Seamless 8×8 pixel-art tiles used as a decorative background pattern on each
 * passive card, themed to the passive (medical crosses, rising peaks, brick
 * wall, energy stripes, echo diamonds). Rendered tiled at low opacity so the
 * card reads as ornamented rather than illustrated.
 */
export const DECK_PASSIVE_PATTERNS: Partial<Record<DeckPassiveId, readonly string[]>> = {
  steady_recovery: [
    '........',
    '...11...',
    '...11...',
    '.111111.',
    '.111111.',
    '...11...',
    '...11...',
    '........',
  ],
  rising_damage: [
    '...11...',
    '..1111..',
    '.111111.',
    '11111111',
    '...11...',
    '..1111..',
    '.111111.',
    '11111111',
  ],
  armed_structures: [
    '........',
    '.111.111',
    '.111.111',
    '.111.111',
    '........',
    '11.111.1',
    '11.111.1',
    '11.111.1',
  ],
  energy_reserve: [
    '11..11..',
    '.11..11.',
    '..11..11',
    '1..11..1',
    '11..11..',
    '.11..11.',
    '..11..11',
    '1..11..1',
  ],
  echoing_deployment: [
    '...11...',
    '..1..1..',
    '.1....1.',
    '1......1',
    '1......1',
    '.1....1.',
    '..1..1..',
    '...11...',
  ],
};
